"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataFactory = require("@rdfjs/data-model");

var rdf_string_1 = require("rdf-string");

var Factory =
/*#__PURE__*/
function () {
  function Factory(dataFactory) {
    _classCallCheck(this, Factory);

    this.dataFactory = dataFactory || DataFactory;
    this.stringType = this.createTerm('http://www.w3.org/2001/XMLSchema#string');
  }

  _createClass(Factory, [{
    key: "createAlt",
    value: function createAlt(left, right) {
      return {
        type: 'alt',
        left: left,
        right: right
      };
    }
  }, {
    key: "createAsk",
    value: function createAsk(input) {
      return {
        type: 'ask',
        input: input
      };
    }
  }, {
    key: "createBoundAggregate",
    value: function createBoundAggregate(variable, aggregate, expression, distinct, separator) {
      var result = this.createAggregateExpression(aggregate, expression, distinct, separator);
      result.variable = variable;
      return result;
    }
  }, {
    key: "createBgp",
    value: function createBgp(patterns) {
      return {
        type: 'bgp',
        patterns: patterns
      };
    }
  }, {
    key: "createConstruct",
    value: function createConstruct(input, template) {
      return {
        type: 'construct',
        input: input,
        template: template
      };
    }
  }, {
    key: "createDescribe",
    value: function createDescribe(input, terms) {
      return {
        type: 'describe',
        input: input,
        terms: terms
      };
    }
  }, {
    key: "createDistinct",
    value: function createDistinct(input) {
      return {
        type: 'distinct',
        input: input
      };
    }
  }, {
    key: "createExtend",
    value: function createExtend(input, variable, expression) {
      return {
        type: 'extend',
        input: input,
        variable: variable,
        expression: expression
      };
    }
  }, {
    key: "createFrom",
    value: function createFrom(input, def, named) {
      return {
        type: 'from',
        input: input,
        default: def,
        named: named
      };
    }
  }, {
    key: "createFilter",
    value: function createFilter(input, expression) {
      return {
        type: 'filter',
        input: input,
        expression: expression
      };
    }
  }, {
    key: "createGraph",
    value: function createGraph(input, name) {
      return {
        type: 'graph',
        input: input,
        name: name
      };
    }
  }, {
    key: "createGroup",
    value: function createGroup(input, variables, aggregates) {
      return {
        type: 'group',
        input: input,
        variables: variables,
        aggregates: aggregates
      };
    }
  }, {
    key: "createInv",
    value: function createInv(path) {
      return {
        type: 'inv',
        path: path
      };
    }
  }, {
    key: "createJoin",
    value: function createJoin(left, right) {
      return {
        type: 'join',
        left: left,
        right: right
      };
    }
  }, {
    key: "createLeftJoin",
    value: function createLeftJoin(left, right, expression) {
      if (expression) return {
        type: 'leftjoin',
        left: left,
        right: right,
        expression: expression
      };
      return {
        type: 'leftjoin',
        left: left,
        right: right
      };
    }
  }, {
    key: "createLink",
    value: function createLink(iri) {
      return {
        type: 'link',
        iri: iri
      };
    }
  }, {
    key: "createMinus",
    value: function createMinus(left, right) {
      return {
        type: 'minus',
        left: left,
        right: right
      };
    }
  }, {
    key: "createNps",
    value: function createNps(iris) {
      return {
        type: 'nps',
        iris: iris
      };
    }
  }, {
    key: "createOneOrMorePath",
    value: function createOneOrMorePath(path) {
      return {
        type: 'OneOrMorePath',
        path: path
      };
    }
  }, {
    key: "createOrderBy",
    value: function createOrderBy(input, expressions) {
      return {
        type: 'orderby',
        input: input,
        expressions: expressions
      };
    }
  }, {
    key: "createPath",
    value: function createPath(subject, predicate, object, graph) {
      if (graph) return {
        type: 'path',
        subject: subject,
        predicate: predicate,
        object: object,
        graph: graph
      };
      return {
        type: 'path',
        subject: subject,
        predicate: predicate,
        object: object,
        graph: this.dataFactory.defaultGraph()
      };
    }
  }, {
    key: "createPattern",
    value: function createPattern(subject, predicate, object, graph) {
      var pattern;
      if (graph) pattern = this.dataFactory.quad(subject, predicate, object, graph);else pattern = this.dataFactory.triple(subject, predicate, object);
      pattern.type = 'pattern';
      return pattern;
    }
  }, {
    key: "createProject",
    value: function createProject(input, variables) {
      return {
        type: 'project',
        input: input,
        variables: variables
      };
    }
  }, {
    key: "createReduced",
    value: function createReduced(input) {
      return {
        type: 'reduced',
        input: input
      };
    }
  }, {
    key: "createSeq",
    value: function createSeq(left, right) {
      return {
        type: 'seq',
        left: left,
        right: right
      };
    }
  }, {
    key: "createService",
    value: function createService(input, name, silent) {
      return {
        type: 'service',
        input: input,
        name: name,
        silent: silent
      };
    }
  }, {
    key: "createSlice",
    value: function createSlice(input, start, length) {
      if (start === undefined) start = 0;
      if (length !== undefined) return {
        type: 'slice',
        input: input,
        start: start,
        length: length
      };
      return {
        type: 'slice',
        input: input,
        start: start
      };
    }
  }, {
    key: "createUnion",
    value: function createUnion(left, right) {
      return {
        type: 'union',
        left: left,
        right: right
      };
    }
  }, {
    key: "createValues",
    value: function createValues(variables, bindings) {
      return {
        type: 'values',
        variables: variables,
        bindings: bindings
      };
    }
  }, {
    key: "createZeroOrMorePath",
    value: function createZeroOrMorePath(path) {
      return {
        type: 'ZeroOrMorePath',
        path: path
      };
    }
  }, {
    key: "createZeroOrOnePath",
    value: function createZeroOrOnePath(path) {
      return {
        type: 'ZeroOrOnePath',
        path: path
      };
    }
  }, {
    key: "createAggregateExpression",
    value: function createAggregateExpression(aggregator, expression, distinct, separator) {
      if (separator) return {
        type: 'expression',
        expressionType: 'aggregate',
        aggregator: aggregator,
        expression: expression,
        separator: separator,
        distinct: distinct
      };
      return {
        type: 'expression',
        expressionType: 'aggregate',
        aggregator: aggregator,
        expression: expression,
        distinct: distinct
      };
    }
  }, {
    key: "createExistenceExpression",
    value: function createExistenceExpression(not, input) {
      return {
        type: 'expression',
        expressionType: 'existence',
        not: not,
        input: input
      };
    }
  }, {
    key: "createNamedExpression",
    value: function createNamedExpression(name, args) {
      return {
        type: 'expression',
        expressionType: 'named',
        name: name,
        args: args
      };
    }
  }, {
    key: "createOperatorExpression",
    value: function createOperatorExpression(operator, args) {
      return {
        type: 'expression',
        expressionType: 'operator',
        operator: operator,
        args: args
      };
    }
  }, {
    key: "createTermExpression",
    value: function createTermExpression(term) {
      return {
        type: 'expression',
        expressionType: 'term',
        term: term
      };
    }
  }, {
    key: "createTerm",
    value: function createTerm(str) {
      return rdf_string_1.stringToTerm(str, this.dataFactory);
    }
  }]);

  return Factory;
}();

exports.default = Factory;